import React from 'react'
import './MechSelector.scss'
import { MechProduct } from '../types/productTypes'
import classNames from 'classnames'
import { SmallPill } from './SmallPill'

interface Props {
  mechProduct: MechProduct
  onClick: () => void
  isSelected: boolean
  collapsed: boolean
}


export default function MechSelector({ onClick, mechProduct, isSelected, collapsed }: Props) {
  return (
    <div className={classNames('MechSelector', isSelected ? '_isSelected' : '', { collapsed })} onClick={onClick}>
      {
        collapsed && (
          <div>
            <div className="itemNumber">
              {mechProduct.itemNo}
            </div>
          </div>
        )
      }
      {
        !collapsed && (
          <div>
            <div className="itemNumber">
              {mechProduct.itemNo}
              {mechProduct.includesLed && (<SmallPill isInverse>LED Included</SmallPill>)}
              {!mechProduct.includesLed && mechProduct.supportsLed && (<SmallPill isInverse>LED Compatible</SmallPill>)}
            </div>
            <div>
              {mechProduct.displayName}
            </div>
          </div>
        )
      }

      {/*<div className="imageWrapper">*/}
      {/*  <FillImageView*/}
      {/*    src={getProductImageUrl(mechProduct.image)}*/}
      {/*    placeholder={PlaceholderInterface}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  )
}